import request from '../util/request'

export const getSurveyors = (params) => {
  return request({
    url: '/pr/surveyors',
    method: 'get',
    params
  })
}

export const createSurveyor = (data) => {
  return request({
    url: '/pr/surveyors',
    method: 'post',
    data
  })
}

export const editSurveyor = (data) => {
  return request({
    url: `/pr/surveyors/${data.id}`,
    method: 'put',
    data
  })
}
export const removeSurveyor = (data) => {
  return request({
    url: `/pr/surveyors/${data.id}`,
    method: 'delete',
  })
}